import type { Component } from "solid-js";

interface HexagonSparkleIconProps {
  size?: number;
  class?: string;
}

const HexagonSparkleIcon: Component<HexagonSparkleIconProps> = (props) => {
  const size = props.size || 18;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      width={size}
      height={size}
      class={props.class}
    >
      {/* Hexagon outline */}
      <path
        d="M10.5 2.577a3 3 0 0 1 3 0l6.062 3.5a3 3 0 0 1 1.5 2.598v7a3 3 0 0 1-1.5 2.598l-6.062 3.5a3 3 0 0 1-3 0l-6.062-3.5a3 3 0 0 1-1.5-2.598v-7a3 3 0 0 1 1.5-2.598l6.062-3.5z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      {/* Sparkle inside */}
      <path
        d="M12 7.5a.375.375 0 0 1 .36.272l.407 1.423a1.875 1.875 0 0 0 1.288 1.288l1.423.407a.375.375 0 0 1 0 .72l-1.423.407a1.875 1.875 0 0 0-1.288 1.288l-.407 1.423a.375.375 0 0 1-.72 0l-.407-1.423a1.875 1.875 0 0 0-1.288-1.288l-1.423-.407a.375.375 0 0 1 0-.72l1.423-.407a1.875 1.875 0 0 0 1.288-1.288l.407-1.423A.375.375 0 0 1 12 7.5z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HexagonSparkleIcon;
